export default __webpack_public_path__ + "static/media/portfolio-56.8acb623f.jpg";